import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { PrimaryButton } from 'appSrc/components/UI';
import style from './styles/style.module.css';

import ImageCropDiv from 'appSrc/components/ImageUpload/CropDiv';

import closeIcon from 'appSrc/assets/img/close.svg';

class ImageCropModal  extends PureComponent {
    constructor(props) {
        super(props);
        this.cropImage = this.cropImage.bind( this );
        this.cancelCrop = this.cancelCrop.bind( this );
        this.setReady = this.setReady.bind( this );
        this.setLoading = this.setLoading.bind( this );

        this.state = {
            cropperReady: false,
            isConverting: false,
        };
    }
    cropImage() {
        if( this.props.cropConversion ) {
            var cropData = this.cropDivWrapper.getCropData();
            this.props.onFinish( cropData );
        } else {
            this.cropDivWrapper.cropImage()
            .then( ( imageDataUrl ) => {
                this.props.onFinish( imageDataUrl );
            } );
        }
    }
    setReady() {
        this.setState( { cropperReady: true } );
        this.cropDivWrapper = this._cropDiv;
    }
    setLoading( isLoading ) {
        this.setState( { isConverting: isLoading } );
    }
    cancelCrop() {
        this.props.onFinish( null );
    }
    render() {
        const { src } = this.props;
        return (
            <ReactModal
            isOpen={ true }
            contentLabel="Create New List"
            shouldCloseOnOverlayClick={ true }
            className={ `modal-popup ${ style.croppingModal }` }
            overlayClassName='modal-overlay'
            >
                <div className={ style.close }>
                    <img src={ closeIcon } onClick={ this.cancelCrop } />
                </div>
                <ImageCropDiv
                className={ style.imageBlock }
                src={ src }
                ready={ this.setReady }
                loading={ this.setLoading }
                aspectRatio={ this.props.aspectRatio }
                childRef={ ( el ) => { this._cropDiv = el; } } />
                <div className={ style.controls }>
                    <p>Position photo within cropping window.
                        <br/>Maximum image size is 15MB.</p>
                    <PrimaryButton
                    label="Upload Photo"
                    className={ style.buttonText }
                    onClick={ this.cropImage }
                    disabled={ !this.state.cropperReady || this.state.isConverting } />
                </div>
            </ReactModal>
        );
    }
}
ImageCropModal.propTypes = {
    src: PropTypes.string.isRequired,
    onFinish: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
    };
};

export default connect( mapStateToProps )( ImageCropModal );
